/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PatchCustomerV1Dto = {
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The name of the customer.
   */
  name: string;
  /**
   * The country of the customer.
   */
  country: string;
  /**
   * The accounting area of the customer (Buchungskreis).
   */
  accountingArea?: string | null;
  /**
   * The VAT number of the customer (Umsatzsteuer-Identifikationsnummer).
   */
  vat?: string | null;
  /**
   * The language of correspondence with the customer.
   */
  languageOfCorrespondence?: PatchCustomerV1Dto.languageOfCorrespondence | null;
  /**
   * The uuid of the customer-group linked to this customer. As 8-4-4-4-12 format.
   */
  customerGroupId?: string | null;
  /**
   * the default vat rate in percent of the customer.
   */
  vatRate?: number;
  /**
   * Indicates if the customer is a group admin.
   */
  isGroupAdmin: boolean;
  /**
   * The uuid of the address linked to this customer. As 8-4-4-4-12 format.
   */
  addressIds?: Array<string> | null;
};
export namespace PatchCustomerV1Dto {
  /**
   * The language of correspondence with the customer.
   */
  export enum languageOfCorrespondence {
    GERMAN = 'german',
    ENGLISH = 'english',
  }
}
